import { createSelector } from 'reselect';
import config from '../../config';
import get from 'lodash/get';
import { positionSelector } from './positionSelectors';
export var getMarginProductById = function getMarginProductById(id) {
  return createSelector([function (state) {
    return state.margin.product.products;
  }], function (products) {
    return products.find(function (p) {
      return p.AccountPosition.ProductId === id;
    });
  });
};
export var marginProductSelector = createSelector(function (state) {
  return state.margin.product.products;
}, positionSelector, function (state) {
  return state.apexCore.product.products;
}, function (state) {
  return state.productManifest.manifest;
}, function (state) {
  return state.user.userConfig;
}, function () {
  return config;
}, function (marginProducts, positions, products, manifest, userConfig, apexWebConfig) {
  var BaseCurrency = (userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  }) || {}).Value || 'USD';
  var supportedProducts = get(apexWebConfig, 'global.products', []);
  var standardProducts = Object.values(products);
  return marginProducts.filter(function (product) {
    var stdProduct = standardProducts.find(function (i) {
      return i.ProductId === product.AccountPosition.ProductId;
    });
    if (!stdProduct || get(stdProduct, 'IsDisabled', true)) return false;
    if (!supportedProducts.length) return true;
    return supportedProducts.includes(product.AccountPosition.ProductSymbol);
  }).map(function (product) {
    var position = product.AccountPosition;
    var standardProduct = Object.values(products).find(function (standardProduct) {
      return standardProduct.ProductId === position.ProductId;
    });
    var standardPosition = positions[standardProduct.ProductId];
    var StandardAmount = standardPosition ? standardPosition.Amount : 0;
    var ProductSymbol = standardPosition ? standardPosition.ProductSymbol : product.AccountPosition.ProductSymbol;
    var iconFileName = manifest[ProductSymbol] ? manifest[ProductSymbol].iconFileName : ProductSymbol + 'DEFAULT_ICON';
    var ProductFullName = standardProduct ? standardProduct.ProductFullName : '';
    return {
      ProductId: position.ProductId,
      MarginAmount: position.Amount,
      BorrowingPower: product.BorrowingPower,
      ProductPrice: product.ProductPrice,
      BaseCurrency: BaseCurrency,
      StandardAmount: StandardAmount,
      iconFileName: iconFileName,
      ProductFullName: ProductFullName,
      ProductSymbol: ProductSymbol,
      Hold: product.AccountPosition.Hold
    };
  });
});
export var productsTotalAmountSelector = createSelector(marginProductSelector, function (state) {
  return state.user.userConfig;
}, function (products, userConfig) {
  var baseCurrency = (userConfig.find(function (config) {
    return config.Key === 'BaseCurrency';
  }) || {}).Value || 'USD';
  var standardTotalValue = 0;
  var marginTotalValue = 0;
  var borrowingTotalValue = 0;
  products.forEach(function (product) {
    standardTotalValue += product.StandardAmount * product.ProductPrice;
    marginTotalValue += product.MarginAmount * product.ProductPrice;
  });
  if (products.length > 0) {
    borrowingTotalValue = products[0].BorrowingPower * products[0].ProductPrice;
  }
  return {
    StandardTotalValue: standardTotalValue,
    MarginTotalValue: marginTotalValue,
    BorrowingTotalValue: borrowingTotalValue,
    BaseCurrency: baseCurrency
  };
});